<template>
  <v-text-field
    outlined
    @blur="handleValid(); emitValue('blur', $event);"
    v-bind="$attrs"
    :value="maskedValue"
    :rules="emailOrPhoneRules(required)"
    @input="handleValid(); emitValue('input', $event);"
    ref="emailOrPhone"
  ></v-text-field>
</template>

<script>
import * as validator from 'email-validator';

export default {
  name: 'EsEmailPhoneField',
  props: {
    value: String,
    required: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  mounted() {
    if (this.value) {
      this.$refs.emailOrPhone.focus();
      this.$nextTick(this.$refs.emailOrPhone.blur());
    }
  },
  data: () => ({
    maskedValue: null,
    valueToEmit: null,
  }),
  methods: {
    handleValid() {
      const errorState = this.$refs.emailOrPhone.hasError;
      this.$emit('isInvalid', errorState);
    },
    emailOrPhoneRules(req) {
      return [
        (v) => (!!v || !req) || 'Email or phone is required',
        (v) => (!v || validator.validate(v) || /^[+](\d{10}|\d{11}|\d{12})$/.test(this.valueToEmit)) || 'Please enter a valid email address or phone number.',
      ];
    },
    emitValue(type, event) {
      this.valueToEmit = event;
      const eventType = event?.srcElement?._value || event;
      let formattedValue = eventType;
      const containsLettersRegex = /[a-zA-Z]/g;
      if (typeof eventType === 'object' || containsLettersRegex.test(eventType)) {
        formattedValue = eventType
      } else {
        formattedValue = eventType?.replace(/\D/g, '')
      }
      if (this.isValidPhone(formattedValue)) {
        if (formattedValue?.length === 10) {
          this.maskedValue = `(${formattedValue.substr(0, 3)}) ${formattedValue.substr(3, 3)}-${formattedValue.substr(6, 4)}`;
        } else if (formattedValue?.length === 11) {
          this.maskedValue = `+${formattedValue.substr(0, 1)} (${formattedValue.substr(1, 3)}) ${formattedValue.substr(4, 3)}-${formattedValue.substr(7, 4)}`;
        } else if (formattedValue?.length === 12) {
          this.maskedValue = `+${formattedValue.substr(0, 2)} (${formattedValue.substr(2, 3)}) ${formattedValue.substr(5, 3)}-${formattedValue.substr(8, 4)}`;
        } 
        this.valueToEmit = `+${formattedValue}`;
      }
      this.$emit(type, this.valueToEmit);
    },
    isValidPhone(value) {
      return /^(\d{10}|\d{11}|\d{12})$/.test(value);
    }
  },
};
</script>
